import { render, staticRenderFns } from "./TsJobCompanyPane.vue?vue&type=template&id=6016475f"
import script from "./TsJobCompanyPane.vue?vue&type=script&lang=ts"
export * from "./TsJobCompanyPane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports